const state = {
  activityConfigForm: {},
  searchUid: 0,
  orderForm: {},
  rewardForm: {},
  rewardForm2: {}
}
const mutations = {
  ACTIVITYCONFIGFORM: (state, { value }) => {
    state.activityConfigForm = value
  },
  ORDERFORM: (state, { value }) => {
    state.orderForm = value
  },
  REWARDFORM: (state, { value }) => {
    state.rewardForm = value
  },
  REWARDFORM2: (state, { value }) => {
    state.rewardForm2 = value
  },
  USERSEARCHGFORM: (state, { uid }) => {
    state.searchUid = uid
  }
}

const actions = {
  activityConfigForm({ commit }, data) {
    commit('ACTIVITYCONFIGFORM', data)
  },
  userSearchForm({ commit }, data) {
    commit('USERSEARCHGFORM', data)
  },
  orderForm({ commit }, data) {
    commit('ORDERFORM', data)
  },
  rewardForm({ commit }, data) {
    commit('REWARDFORM', data)
  },
  rewardForm2({ commit }, data) {
    commit('REWARDFORM2', data)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
